import { INotificationRecurrence } from '@communication-center/data-objects';
import { numbersStr, days, months } from './SelectReoccurrence';
import i18n from '../../../../../infrastructure/I18n/i18n';

const keyPrefix = 'components.editNotification.editNotificationContent.sendStepDrawer.selectReoccurrence.selectReoccurrence';

export const reoccurrencesDescription = (recurrenceData?: INotificationRecurrence) => {
    const t = (key: string, params?: any) => i18n.t(`${keyPrefix}.reoccurrencesDescription.${key}`, params);
    const tt = (key: string, params?: any) => i18n.t(`${keyPrefix}.${key}`, params);

    if (!recurrenceData || Object.keys(recurrenceData).length === 0) return null;

    let text = '';
    if (recurrenceData.yearRules?.yearsRepeat) {
        if (recurrenceData.yearRules.yearsRepeat == 1) {
            text += t('annually');
        } else {
            text += t('everyYears', { number: recurrenceData.yearRules.yearsRepeat });
        }

        if (recurrenceData.dayRules?.daysInMonth?.length == 1 && recurrenceData.monthRules?.monthsInYear?.length == 1) {
            text += t('onMonthDay', {
                month: tt(`months.${months[recurrenceData.monthRules.monthsInYear[0]]}`),
                day: recurrenceData.dayRules?.daysInMonth[0]
            });
        }

        return text;
    }

    if (recurrenceData.monthRules?.monthsRepeat) {
        if (recurrenceData.monthRules.monthsRepeat == 1) {
            text += t('monthly');
        } else {
            text += t('everyMonths', { number: recurrenceData.monthRules.monthsRepeat });
        }

        if (recurrenceData.dayRules?.daysInMonth?.length == 1) {
            text += t('onDay', { number: recurrenceData.dayRules?.daysInMonth[0] });
        } else if (recurrenceData.dayRules?.daysInWeek?.length == 1 && recurrenceData.weekRules?.weeksInMonth?.length == 1) {
            text += t('onNthDay', {
                nth: tt(`numbersStr.${numbersStr[recurrenceData.weekRules.weeksInMonth[0]]}`),
                day: tt(`days.${days[recurrenceData.dayRules.daysInWeek[0]]}`)
            });
        }

        return text;
    }

    if (recurrenceData.weekRules?.weeksRepeat) {
        if (recurrenceData.weekRules.weeksRepeat == 1) {
            text += t('weekly');
        } else {
            text += t('everyWeeks', { number: recurrenceData.weekRules.weeksRepeat });
        }

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        if (recurrenceData.dayRules?.daysInWeek?.length > 0) {
            text += t('on');
            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            switch (recurrenceData.dayRules.daysInWeek.length) {
                case 7:
                    text += t('evertDay');
                    break;
                case 1:
                    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
                    text += tt(`days.${days[recurrenceData.dayRules.daysInWeek[0]]}`);
                    break;
                default: {
                    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
                    const daysInWeek = recurrenceData.dayRules.daysInWeek.slice().sort();
                    text += `${daysInWeek
                        .slice(0, -1)
                        .map(day => tt(`days.${days[day]}`))
                        .join(', ')}`;
                    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
                    text += t('andDay', { day: tt(`days.${days[daysInWeek.concat([]).pop()]}`) });
                }
            }
        } else {
            throw new Error('no days provided for weekly recurrence rule');
        }

        return text;
    }

    if (recurrenceData.dayRules?.daysRepeat) {
        if (recurrenceData.dayRules.daysRepeat == 1) {
            text += t('daily');
        } else {
            text += t('everyDays', { number: recurrenceData.dayRules.daysRepeat });
        }
    }

    return text;
};
